import { IModel, IAttribute, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Credential } from '../credential/credential';
import { adxAuthTypes, azureDefaultAuthRefTypes } from '../../interfaces/IAuthenticationType';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.azureDataExplorerLinkedService,
    display: [
        format(
            shellStringResources.ModelName_LinkedServiceTemplate,
            shellStringResources.AzureDataExplorer_DisplayText
        ),
        format(
            shellStringResources.ModelName_LinkedServicesTemplate,
            shellStringResources.AzureDataExplorer_DisplayText
        )
    ]
})
export class AzureDataExplorerLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static readonly TENANT: IAttribute;
    public static readonly ENDPOINT: IAttribute;
    public static readonly DATABASE: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureDataExplorerLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    public authReferenceMethod?: string = azureDefaultAuthRefTypes.InlineRefTypeAuthentication;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AuthenticationType
    })
    public authenticationMethod?: string = adxAuthTypes.ServicePrincipalAuthentication;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        templatable: true
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'TENANT',
        templatable: true
    })
    public tenant?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.Database,
        association: 'DATABASE',
        templatable: true
    })
    public database?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(
        linkedService: AzureDataExplorerLinkedService,
        referencedCredential: Credential
    ): IViolation[] | undefined {
        if (
            (linkedService.authenticationMethod === adxAuthTypes.UserAssignedManagedIdentityAuthentication ||
                linkedService.authenticationMethod === adxAuthTypes.UserAuth ||
                (linkedService.authenticationMethod === adxAuthTypes.ServicePrincipalAuthentication &&
                    linkedService.authReferenceMethod === azureDefaultAuthRefTypes.CredentialRefTypeAuthentication)) &&
            !referencedCredential
        ) {
            return [
                {
                    context: linkedService,
                    message: () => shellStringResources.Error_InvalidCredentialReferenced
                }
            ];
        }
        return undefined;
    }
}
